import { createContext, useContext } from 'react';
export const FieldAttributesContext = createContext(undefined);
export function useFieldAttributes() {
    const context = useContext(FieldAttributesContext);
    if (typeof context === 'undefined') {
        throw new Error('useFieldAttributes must be used inside a <FieldAttributesContext.Provider>');
    }
    return context;
}

//# sourceMappingURL=field-attributes-context.js.map